import { errorMessages } from '../message/errorMessages';

/**
 * 依存クラス： Validator
 */
export class FormItemChecker
{
  /**
   *コンストラクタ
   * @param { instances[] } validators
   * @param { HTMLElement } formItem
   */
  constructor( validators, formItem ) {
    this.target         = formItem;
    this.errorEl        = formItem.querySelector( '.p-error' ) || false;
    this.errorElText    = formItem.querySelector( '.p-error__text' ) || false;
    this.checkIcon      = formItem.querySelector( '.p-form-item__status-icon' ) || false;
    this.attributeNames = this.target.getAttributeNames() || false;
    this.validators     = validators;
  }

  /**
   * .p-form-item 内のバリデーションエラーの数を取得する
   * @returns { number }
   */
  getErrorCount = () =>
  {
    let cnt = 0;
    this.validators.forEach( validator => {
      if ( validator.errorCount > 0 ) {
        cnt++;
      }
    } );

    this.attributeNames.forEach( attributeName => {
      /**
       * ,p-form-item 内で一つ以上が必須入力の場合
       */
      if ( attributeName === 'data-required-or' ) {
        let orCounter = 0;
        this.validators.forEach( validator => {
          if ( validator.value != '' ) {
            orCounter++;
          }
        } );
        if ( ! ( orCounter > 0 ) ) {
          cnt++;
          this.reflectErrorMessage( errorMessages.code029 );
        }
      }
    } );

    return cnt;
  }

  /**
   * p-form-item 内のバリデーションエラー数が0以上なら バリデーションエラーを反映
   * @param { String } filter 書き換えるエラーメッセージ内容
   * @return { void }
   */
  reflectErrorMessage = ( filter ) =>
  {
    let msg = '';

    /**
     * エラーメッセージをリライトする */
    if ( filter ) {
      msg = filter;
      this.errorElText.textContent = msg;

    /**
     * 通常のエラーメッセージ */
    } else {
      // 一番最初にヒットしたエラーを取得
      for ( let i = 0; i < this.validators.length; i++ ) {
        if ( this.validators[i].errorCount > 0 ) {
          msg = this.validators[i].getErrorMessage();
          break;
        }
      }

      if ( this.errorElText ) {
        // HTMLに出力
        this.errorElText.textContent = msg;
      }

      if ( this.errorEl ) {
        const errorNum = this.getErrorCount();
        if ( errorNum === 0 ) {
          this.errorEl.style.display = 'none'; // エラーを隠す
        } else {
          this.errorEl.style.display = 'flex'; // エラーを表示
        }
      }
    }
  }

  /**
   * p-form-item内のエラーに応じて、チェックアイコンの色を変化させる
   * @returns { void }
   */
  reflectToggleCheckIcon = () =>
  {
    if ( this.checkIcon ) {
      const errorNum = this.getErrorCount();
      if ( errorNum > 0 ) {
        this.checkIcon.classList.add( 'c-icon--success-off' );
        this.checkIcon.classList.remove( 'c-icon--success' );
      } else {
        this.checkIcon.classList.add( 'c-icon--success' );
        this.checkIcon.classList.remove( 'c-icon--success-off' );
      }
    }
  }

  /**
   * .p-form-item 内のバリデーションエラー数を取得
   * @returns { number }
   */
  getErrorNum = () =>
  {
    let cnt = 0;
    this.validators.forEach( validator => {
      if ( validator.getErrorCount > 0 ) {
        cnt++;
      }
    } );

    return cnt;
  }

  /**
   * .p-form-item 内のバリデーションを実行する
   * @returns { void }
   */
  validateRunThisFormItem = () =>
  {
    this.validators.forEach( validator => {
      validator.validateRun();
    } );
  }
}
